
























import * as _ from 'lodash';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {Getter, namespace} from 'vuex-class';
import {ProjectMetadata, ProjectsMetadata} from '../../metadata/projects-metadata.d';

const MainGetter = namespace('main', Getter);

@Component
export default class MainToolbar extends Vue {
  @MainGetter('availableProjects') private availableProjects: ProjectsMetadata;

  @Prop({default: 'main'}) private mode: string;

  private onSelect(selectedRoute: string, routePaths: string) {
    if (selectedRoute === 'back') {
      this.goBack();
    } else {
      const route = routePaths[0];

      if (route === 'about') {
        this.$router.push({name: selectedRoute});
      } else if (route === 'projects') {
        const project = _.find(this.availableProjects, ['id', selectedRoute]) as ProjectMetadata;
        this.$router.push({name: routePaths[0], params: {id: selectedRoute}});
      }
    }
  }

  private goBack() {
    window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/toolbar/toolbar.vue